import styled from 'styled-components';
import ArrowWhiteIcon from '@/assets/mo/arrow-white.svg?react';
import { motion, AnimatePresence } from 'framer-motion';
import { useQuery } from '@tanstack/react-query';
import { fetchNotices } from '@/api/notice';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const NoticeBanner = () => {
  const navigate = useNavigate();
  const {
    data: notices,
    isLoading,
    isError,
  } = useQuery({
    queryKey: ['notices'],
    queryFn: fetchNotices,
  });

  const [current, setCurrent] = useState(0);

  useEffect(() => {
    if (!notices || notices.length <= 1) return;
    const timer = setInterval(() => {
      setCurrent((prev) => (prev + 1) % notices.length);
    }, 4000); // 4초마다 변경
    return () => clearInterval(timer);
  }, [notices]);

  if (isLoading || isError || !notices || notices.length === 0) return null;

  return (
    <BannerWrapper>
      <NoticeContent onClick={() => navigate(`/intro/news/${notices[current].id}`)}>
        <NoticeLabel>소식</NoticeLabel>
        <TextBox>
          <AnimatePresence mode="wait">
            <SlideText
              key={notices[current].id}
              initial={{ y: 20, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              exit={{ y: -20, opacity: 0 }}
              transition={{ duration: 0.4 }}
            >
              {notices[current].title}
            </SlideText>
          </AnimatePresence>
        </TextBox>
        <ArrowWhiteIcon />
      </NoticeContent>
    </BannerWrapper>
  );
};

export default NoticeBanner;

// Styled Components
const BannerWrapper = styled.div`
  display: flex;
  width: 100%;
  height: 60px;
  padding: 8px 16px;
  align-items: center;
  gap: 8px;
  border-radius: 99px;
  border: 1px solid var(--button-solid-solid01, #f5f5f5);
  background: var(--Primary-white, #fff);
  overflow: hidden;
`;

const NoticeContent = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1 0 0;
`;

const NoticeLabel = styled.div`
  display: flex;
  padding: 4px 10px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 99px;
  background: var(--gray-ui_gray04, #6f6f6f);
  color: var(--Primary-white, #fff);
  text-align: center;
  font-size: 12px;
  font-weight: 500;
  line-height: 120%;
  letter-spacing: -0.24px;
`;

const TextBox = styled.div`
  position: relative;
  height: 14px;
  overflow: hidden;
  flex: 1 0 0;
`;

const SlideText = styled(motion.div)`
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
  text-overflow: ellipsis;

  color: var(--gray-ui_gray03, #3a3a3a);
  font-family: 'Spoqa Han Sans Neo';
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  line-height: 120%;
  letter-spacing: -0.24px;
  margin-right: 4px;
`;
